<template>
    <div class="view bg-light">
        <simbar-header />
        <div class="view-title bg-white">
            <div class="container px-0">
                <h2>Meu perfil</h2>
            </div>
        </div>
        <main class="container view-container p-4 card shadow-sm my-3">
            <b-card no-body class="flex-fill">
                <b-tabs card>
                    <user-tab />
                </b-tabs>
            </b-card>
        </main>
        <simbar-footer />
    </div>
</template>

<script>
import SimbarHeader from "@/modules/dashboard/components/SimbarHeader";
import SimbarFooter from "@/modules/dashboard/components/SimbarFooter";
import UserTab from "./user/UserTab";

export default {
    name: "Profile",
    components: {
        UserTab,
        SimbarHeader,
        SimbarFooter
    }
};
</script>
